import { Component, inject } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { AuthStore, RealUserDirective } from '@easihub/ngx';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCircleUser } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'account-widget',
  templateUrl: './account.widget.html',
  imports: [
    MatMenuModule,
    MatDividerModule,
    MatRippleModule,
    RouterModule,
    FontAwesomeModule,
    RealUserDirective
  ]
})
export class AccountWidgetComponent {

  private readonly auth = inject(AuthStore);

  protected readonly user = this.auth.user;

  protected readonly icons = {
    faCircleUser
  };

  protected signIn() {
    this.auth.signIn.easihub();
  }

  protected signOut(event: Event) {
    // keep the click from reaching the menu, which would close it mid-sign-out
    event.stopImmediatePropagation();
    this.auth.signOut();
  }
}
